<template>
  <div class="pdf-modal-wrapper">
    <canvas
      v-if="boundingBox && currentPage"
      id="provenance-overlay"
      :style="{ left: originX + offsetLeft + 'px', top: originY + 'px' }"
      :width="width"
      :height="height"
    ></canvas>
    <div class="header-styling">
      <div class="btn-wrapper">
        <div class="btn-center">
          <v-btn class="action-btn" height="40" @click="this.goBack">
            <font-awesome-icon icon="fa-regular fa-arrow-left" size="2x" />
          </v-btn>
          <div class="pdf-title" v-if="fetchedPages[pageIndex] && fetchedPages[pageIndex].page">
            {{ name }}
          </div>
        </div>
        <div class="btn-center">
          <v-btn class="action-btn" height="40" @click="this.download">
            <font-awesome-icon icon="fa-regular fa-download" size="2x" />
          </v-btn>
          <v-btn
            v-if="!isSharedProfileView && !this.$route.query.viewShareOption"
            class="action-btn"
            height="40"
            @click="this.toggleSharingModal"
          >
            <font-awesome-icon icon="fa-regular fa-share" size="2x" />
          </v-btn>
        </div>
      </div>
      <!-- <div
        class="pdf-title"
        v-if="!hidePageNumber && fetchedPages[pageIndex] && fetchedPages[pageIndex].page"
      >
        Page {{ selectPage || fetchedPages[pageIndex].page }} of
        {{ fetchedPages[pageIndex].total }}
      </div> -->
    </div>
    <div v-if="error" style="text-align: center">No Preview Available</div>
    <div else v-if="currentPage" class="card-img">
      <img :src="currentPage" ref="documentImage" class="img-container" />
    </div>
    <div class="previous-next-btn-wrapper" v-if="currentPage && !(disableLeft && disableRight)">
      <v-btn @click="$emit('prevPage')" v-if="!disableLeft" text icon>
        <font-awesome-icon icon="fa-solid fa-circle-chevron-left" size="2x" />
      </v-btn>
      <v-btn text icon style="float: right" @click="$emit('nextPage')" v-if="!disableRight">
        <font-awesome-icon icon="fa-solid fa-circle-chevron-right" size="2x" />
      </v-btn>
    </div>
    <v-footer fixed color="#000" height="50" />
    <ShareModel
      :opened="shareModalOpened"
      :userId="getUserId"
      @toggleSharingModal="toggleSharingModal"
      :documentToShare="doc"
    />
  </div>
</template>

<script>
import ShareModel from '../component-library/share-model.vue'
import FontAwesomeIcon from '../component-library/font-awesome-icon.vue'
import Utils from '../utils/helpers'
import { Config } from '@ciitizen/api'

export default {
  name: 'PdfViewer',
  props: {
    name: {
      type: String,
      default: ''
    },
    fetchedPages: {
      type: Array,
      default: () => []
    },
    pageIndex: {
      type: Number,
      default: 0
    },
    selectPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: String,
      default: ''
    },
    disableLeft: {
      type: Boolean,
      default: false
    },
    disableRight: {
      type: Boolean,
      default: false
    },
    hidePageNumber: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    getUserId: {
      type: String,
      default: null
    },
    doc: {
      type: Object,
      default: () => {}
    },
    isSharedProfileView: {
      type: Boolean,
      default: false
    },
    grantor: {
      type: String,
      default: ''
    },
    boundingBox: {
      type: Array,
      default: null
    },
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      shareModalOpened: false,
      width: 0,
      height: 0,
      originX: 0,
      originY: 0,
      offsetLeft: 0,
      navigateFromCancerSummary: false
    }
  },
  components: {
    ShareModel,
    FontAwesomeIcon
  },
  mounted() {
    document.getElementById('app').style.backgroundColor = '#F1F1F7'
  },
  methods: {
    toggleSharingModal() {
      Utils.callSegmentTrack({ name: 'pp.document_share.clicked' })
      this.shareModalOpened = !this.shareModalOpened
    },
    download() {
      let href = this.doc.location
      let filename = this.doc.filename
      if (href.includes('ciitizen-file-service.default')) {
        let ext = filename.split('.')
        ext = ext[ext.length - 1]
        href = `${Config}/file/${this.doc.id}.${ext.toLowerCase()}`
      }
      if (this.isSharedProfileView) {
        href = href.replace('file/', `file/${this.grantor}/`)
      }
      Utils.downloadDocument(href, filename, this.token)
      Utils.callSegmentTrack({ name: 'pp.download.document.clicked' })
    },
    goBack() {
      document.getElementById('app').style.backgroundColor = '#FFFFFF'
      this.$router.back()
    },
    calculate() {
      if (this.boundingBox && this.boundingBox.length === 4 && this.$refs.documentImage) {
        let options = {
          originalWidth: this.$refs.documentImage.naturalWidth,
          originalHeight: this.$refs.documentImage.naturalHeight,
          currentWidth: this.$refs.documentImage.clientWidth,
          currentHeight: this.$refs.documentImage.clientHeight,
          boundingWidth: this.boundingBox[2],
          boundingHeight: this.boundingBox[3],
          boundingOriginX: this.boundingBox[0],
          boundingOriginY: this.boundingBox[1],
          offsetLeft: this.$refs.documentImage.offsetLeft
        }

        let calculated = Utils.calculateBoundingBox(options)
        this.width = calculated.width
        this.height = calculated.height
        this.originX = calculated.originX
        this.originY = calculated.originY
        this.offsetLeft = calculated.offsetLeft
      }
    }
  },
  beforeDestroy() {
    document.getElementById('app').style.backgroundColor = '#FFFFFF'
  }
}
</script>

<style scoped>
.pdf-modal-wrapper {
  display: flex;
  flex-direction: column;
  margin: -40px -16px;
}
.header-styling {
  background: #ffffff;
  align-items: center;
  padding: 18px 0;
  box-shadow: 0px 2px 8px rgba(18, 22, 84, 0.12);
}
.pdf-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #161616;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
  flex: 1;
  letter-spacing: 0.01em;
}
.previous-next-btn-wrapper {
  top: 50%;
  width: 100%;
  position: fixed;
  max-width: 880px;
  width: 100%;
}
.btn-wrapper {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  background: #fff;
  justify-content: space-between;
}

.btn-center {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 24px;
}

.action-btn {
  background: none !important;
  background-color: none !important;
  box-shadow: none !important;
}
.card-img {
  max-width: 100%;
  height: auto !important;
  overflow: auto;
  width: 100%;
  margin-top: 50px;
  padding: 0 70px;
}

@media (max-device-width: 640px) {
  .card-img {
    padding: 0 10px;
  }
}
.img-container {
  border: solid 1px #000;
  background-color: #cfcfcf;
  width: inherit;
}

#provenance-overlay {
  border: solid 3px #047be3;
  position: absolute;
  background: rgba(139, 184, 77, 0.1);
}
</style>
